import o from"styled-components";var e=o("div").withConfig({componentId:"sc-1elu1de-0"})(["flex:1;box-sizing:border-box;"]);export{e as Content};
